import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { ExceptionRead } from '../../entities/exception.dto';

@Injectable()
export class ExceptionStore extends AbstractEntityStore<ExceptionRead> {
    constructor() {
        super(PFWmsEntities.Exception);
    }
}
